import { setServiceDescription } from 'src/app/utils/set-service-description.utils';
import { ServiceDto } from '../../interfaces';

export class Service {
  public id: number;
  public description?: string | null;
  public codeService?: string | null;
  public parent?: ServiceChildParent;
  public parentId?: number | null;
  public limiterNatures?: boolean;
  public name?: string;
  public label?: string;
  public key?: number;
  public value?: string | number;
  public selectable?: boolean;
  public childrenRequired?: boolean;
  public children?: ServiceChildParent[];
  public addMailEntrantChild?: boolean;
  public email?: string | null;

  constructor(data?: Partial<Service>) {
    Object.assign(this, data);
    this.description = setServiceDescription(data as ServiceDto);
    this.name = this.description;
    this.label = this.description;

    this.value = this.id;
    this.key = this.id;
  }

  public setServiceDescription(name: string) {
    return (this.description = name);
  }
}

export class ServiceChildParent {
  children?: ServiceChildParentChildren[];
  codeService?: string;
  description?: string;
  id?: number;
  label?: string;
  limiterNatures?: boolean;
  name?: string;
  parentId?: number;
  value?: number;
  parent?: ServiceChildParent;
  key?: number;
  email?: string;

  constructor(data?: Partial<ServiceChildParent>) {
    Object.assign(this, data);
  }
}

export class ServiceChildParentChildren {
  // children array of ServiceChildParent
  label?: string;
  parent: ServiceChildParent;
  value?: number;
  key?: number;

  constructor(data?: Partial<ServiceChildParent>) {
    Object.assign(this, data);
  }
}

export class ServicesPTreeSelect {
  public label: string | null;
  public name: string | null;
  public key: number | string;
  public value: number | string;
  public selectable?: boolean;
  public available?: boolean;
  public children: ServicesPTreeSelect[] = [];

  public codeService?: string | null;
  public description?: string;
  public email?: string;
  public id?: number;
  public limiterNatures?: boolean;
  public parent?: ServicesPTreeSelect;
  public parentId?: number;
}

export class ServicePTreeSelectForActions extends ServicesPTreeSelect {
  expanded?: boolean;
  codeService?: string;
  constructor(data?: Partial<ServicePTreeSelectForActions> | Partial<ServiceDto>, selectableValue: boolean | undefined = undefined) {
    super();
    this.children = [];
    if (data) {
      Object.assign(this, data);
    }
    if (selectableValue !== undefined) {
      this.selectable = selectableValue;
    } else {
      this.selectable = true;
    }
  }
}

export class ServicesOnlyParent {
  selectable: boolean;
  value: number;
  label: string;
  name: string;
  children?: [];
  id: number;
  key: number;
}
export class ServicesOnlyChildren {
  selectable: boolean;
  value: number;
  label: string;
  name: string;
  children?: [];
  id: number;
  key: number;
}
